(() => {
  function init(root) {
    if (root.dataset.toolbarsInitialized) return;
    root.dataset.toolbarsInitialized = 'true';
    const toolbars = [...root.querySelectorAll('[data-promo-toolbar]')];
    const controllers = toolbars.map(toolbar => {
      const toggle = toolbar.querySelector('[data-toolbar-filter-toggle]');
      const label = toggle.querySelector('[data-toolbar-filter-label]');
      const controls = toolbar.querySelector('.thankful20__filters');
      function setOpen(open) {
        toolbar.dataset.filtersOpen = String(open);
        if (controls) controls.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
      }
      function updateCount() {
        const selects = [...toolbar.querySelectorAll('.thankful20__filters select')];
        const chips = [...toolbar.querySelectorAll('[data-colour][aria-pressed="true"], [data-sticker-filter][aria-pressed="true"]')];
        const count = selects.filter(select => select.value).length + chips.filter(button => button.dataset.colour || button.dataset.stickerFilter).length;
        label.textContent = count ? `Filters (${count})` : 'Filters';
      }
      toggle.hidden = false;
      setOpen(false);
      toggle.addEventListener('click', () => setOpen(toolbar.dataset.filtersOpen !== 'true'));
      toolbar.addEventListener('change', updateCount);
      toolbar.addEventListener('click', event => {
        if (event.target.closest('[data-colour], [data-sticker-filter]')) updateCount();
      });
      updateCount();
      return { toolbar, setOpen };
    });
    root.querySelectorAll('.thankful20__section-nav a').forEach(link => {
      link.addEventListener('click', () => {
        controllers.forEach(controller => controller.setOpen(false));
      });
    });
  }
  document.querySelectorAll('[data-thankful20]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    if (event.target.matches('[data-thankful20]')) init(event.target);
    event.target.querySelectorAll('[data-thankful20]').forEach(init);
  });
})();
